import React from 'react'
import Modal from 'components/modal'
import Button from 'components/controls/button'

const ConfirmEditConferenceLinkModal = props => {
    return(
    <Modal
        title={"Edit Conference Link"}
        isOpen={props.isOpen}
        className="confirmation-modal edit-conference-link-modal"
        type="modal"
        autoFocusSubmit={false}
        submitBtnText="Confirm"
        cancelBtnText="Back"
        onCancel={props.onCancel}
        onSubmit={props.onSubmit}
        isSubmitting={props.isSubmitting}
        showCancelBtn={false}
        additionalButtons={[
            <Button
                className="back"
                onClick={() => props.toggleEditConferenceLinkModal(false, props.editedConferenceLink, props.editedMeetingInformationMap)}
            > Back </Button>
        ]}
    >
        <div className="edit-conference-link-modal-body">
            <div className="edit-conference-link-modal-text">
                <p> {props.t('confirm.update.conference.link.message')}</p>
            </div>
        </div>
    </Modal>
    )
    }
export default ConfirmEditConferenceLinkModal
